(() => {
  if (window.galleryReadMoreLoaded) return;
  window.galleryReadMoreLoaded = true;

  const WRAPPER = '[data-gallery-readmore]';
  const observed = new WeakSet();

  const relatedWrappers = wrapper => {
    const id = wrapper.dataset.galleryReadmoreId;
    if (!id) return [wrapper];
    return [...document.querySelectorAll(WRAPPER + '[data-gallery-readmore-id="' + id + '"]')];
  };

  const refreshCarousel = el => {
    const slider = el.closest('.slick-slider');
    if (slider && window.jQuery && window.jQuery(slider).hasClass('slick-initialized')) {
      window.jQuery(slider).slick('setPosition');
    }
  };

  const updateButtons = wrapper => {
    if (!wrapper) return;
    const text = wrapper.querySelector('[data-gallery-readmore-text]');
    const btnMore = wrapper.querySelector('[data-gallery-readmore-more]');
    const btnLess = wrapper.querySelector('[data-gallery-readmore-less]');
    if (!text || !btnMore || !btnLess) return;

    if (text.classList.contains('is-expanded')) {
      btnMore.style.display = 'none';
      btnLess.style.display = 'block';
      return;
    }

    const isClamped = text.scrollHeight > text.clientHeight + 1;
    btnMore.style.display = isClamped ? 'block' : 'none';
    btnLess.style.display = 'none';
  };

  const setExpanded = (wrapper, expanded) => {
    relatedWrappers(wrapper).forEach(related => {
      const text = related.querySelector('[data-gallery-readmore-text]');
      if (text) text.classList.toggle('is-expanded', expanded);
      updateButtons(related);
    });
    refreshCarousel(wrapper);
  };

  document.addEventListener('click', event => {
    if (!event.target.closest) return;
    const btnMore = event.target.closest('[data-gallery-readmore-more]');
    const btnLess = btnMore ? null : event.target.closest('[data-gallery-readmore-less]');
    if (!btnMore && !btnLess) return;

    const wrapper = (btnMore || btnLess).closest(WRAPPER);
    if (!wrapper) return;

    event.preventDefault();
    setExpanded(wrapper, Boolean(btnMore));
  });

  const resizeObserver =
    typeof ResizeObserver === 'undefined'
      ? null
      : new ResizeObserver(entries => {
          entries.forEach(entry => updateButtons(entry.target.closest(WRAPPER)));
        });

  const init = (scope = document) => {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll(WRAPPER).forEach(wrapper => {
      updateButtons(wrapper);

      const text = wrapper.querySelector('[data-gallery-readmore-text]');
      if (resizeObserver && text && !observed.has(text)) {
        observed.add(text);
        resizeObserver.observe(text);
      }
    });
  };

  window.addEventListener('DOMContentLoaded', () => init());
  window.addEventListener('resize', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:block:select', event => init(event.target));
  if (window.jQuery) {
    window.jQuery(document).on('init.galleryReadMore reInit.galleryReadMore', event => init(event.target));
  }
})();
